export const NATIVE_CHAIN_ID = 'NATIVE'
